import { Center, Spinner } from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import { useGetContributingEntityResponseQuery } from "../../../../autogen/bff-api";
import { useApiError } from "../../../../common/errors/useApiError";
import { PortalLayout } from "../components/PortalLayout";
import { ContributingEntityResponseView } from "./ContributingEntityResponseView";
import { useRecordTitle } from "../../../../common/page-title/PageTitle";

export const ContributingEntityResponsePage = () => {
  const { bidId, contributingEntityId } = useParams<{ bidId: string; contributingEntityId: string }>();
  const displayer = useApiError();

  const { data, error } = useGetContributingEntityResponseQuery(
    { bidId: bidId ?? "", entityId: contributingEntityId ?? "" },
    { skip: !bidId || !contributingEntityId },
  );
  useRecordTitle(data?.context.eventTitle);

  if (error) return displayer.show(error);

  if (!bidId || !contributingEntityId || !data) {
    return (
      <PortalLayout>
        <Center py="24">
          <Spinner color="smPrimary" />
        </Center>
      </PortalLayout>
    );
  }

  return (
    <PortalLayout>
      <ContributingEntityResponseView
        key={contributingEntityId}
        bidId={bidId}
        entityId={contributingEntityId}
        detail={data}
      />
    </PortalLayout>
  );
};
